import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { HERO, STATS, PRODUCTS, COMMUNITY, IMAGES } from "@/data/content";

const DEFAULT_HOME = {
  hero: { ...HERO, image: IMAGES.hero },
  stats: STATS,
  whatWeBuild: PRODUCTS,
  community: {
    ...COMMUNITY,
    image: "/amai-community.jpeg",
    badgeTitle: "AMAI",
    badgeText: "Aeromodellers' Association India (Jodhpur's members)",
  },
};

const SiteContentContext = createContext({ home: DEFAULT_HOME });

export const SiteContentProvider = ({ children }) => {
  const [home, setHome] = useState(DEFAULT_HOME);

  useEffect(() => {
    api
      .get("/content/home")
      .then((r) => setHome(r.data))
      .catch(() => {});
  }, []);

  return (
    <SiteContentContext.Provider value={{ home }}>{children}</SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);
